// extracted by mini-css-extract-plugin
export var skipAnimation = "_2v-0";